// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import AbsenceMonitoringActionForm from "./absence-monitoring-actions-form";
import { View } from "@components";

type OwnProps = $Exact<{
  title: String,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const AbsenceMonitoringAdditionalSupportActionsView = (props: Props) => {
  return (
    <View flexDirection="column">
      <h6>{props.title}</h6>
      <AbsenceMonitoringActionForm {...props} disabled={true} />
    </View>
  );
};

export default localize()(AbsenceMonitoringAdditionalSupportActionsView);
